import axios from '@/libs/api.request';

export const getInvoiceRecord = data => {
    return axios.request({
        url: 'api/financeManagement/invoice/getInvoiceRecord',
        data: data,
        method: 'post'
    });
};

export const webGetInvoice = data => {
    return axios.request({
        url: 'web/financeManagement/invoice/webGetInvoice',
        data: data,
        method: 'post'
    });
};

export const getInvoiceInfo = data => {
    return axios.request({
        url: 'api/financeManagement/invoice/getInvoiceInfo',
        data: data,
        method: 'post'
    });
};

export const saveInvoiceInfo = data => {
    return axios.request({
        url: 'api/financeManagement/invoice/saveInvoiceInfo',
        data: data,
        method: 'post'
    });
};

export const accounterWithdrawInvoice = data => {
    return axios.request({
        url: 'api/financeManagement/invoice/accounterWithdrawInvoice',
        data: data,
        method: 'post'
    });
};

export const getInvoiceAccountList = data => {
    return axios.request({
        url: 'api/financeManagement/invoice/getInvoiceAccountList',
        data: data,
        method: 'post'
    });
};

export const auditInvoiceAccount = data => {
    return axios.request({
        url: 'api/financeManagement/invoice/auditInvoiceAccount',
        data: data,
        method: 'post'
    });
};

export const accounterMarkFinishInvoice = data => {
    return axios.request({
        url: 'api/financeManagement/invoice/accounterMarkFinishInvoice',
        data: data,
        method: 'post'
    });
};
export const getInvoiceAccount = data => {
    return axios.request({
        url: 'api/financeManagement/invoice/getInvoiceAccount',
        data: data,
        method: 'post'
    });
};
export const webApplyInvoice = data => {
    return axios.request({
        url: 'web/financeManagement/invoice/webApplyInvoice',
        data: data,
        method: 'post'
    });
};
export const getPendingInvoiceAmount = data => {
    return axios.request({
        url: 'api/financeManagement/invoice/getPendingInvoiceAmount',
        data: data,
        method: 'post'
    });
};
export const webSubmitInvoice = data => {
    return axios.request({
        url: 'web/financeManagement/invoice/webSubmitInvoice',
        data: data,
        method: 'post'
    });
};
export const applyInvoice = data => {
    return axios.request({
        url: 'api/financeManagement/invoice/applyInvoice',
        data: data,
        method: 'post'
    });
};
export const getPatentFeeInvoiceModel = data => {
    return axios.request({
        url: 'api/invoice/getPatentFeeInvoiceModel',
        data: data,
        method: 'post'
    });
};

export const submitInvoice = data => {
    return axios.request({
        url: 'api/financeManagement/invoice/submitInvoice',
        data: data,
        method: 'post'
    });
};
